/* unplugin-vue-components disabled */import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=74fe0e7c&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fe0e7c"]])

export default __exports__